<template>
    <div v-cloak>
      <nav-header
        ref="navHeader"
        v-bind:showSearch="p_showSearch"
        v-bind:loginModalFlag="p_loginModalFlag"
        v-on:showLoginModal="p_showLoginModal"
        v-on:closeLoginModal="p_closeLoginModal"></nav-header>
      <nav-bread>
        <span slot="confirmSuccess">下单成功</span>
      </nav-bread>
      <div class="container">
        <div class="page-title-normal">
          <h2 class="page-title-h2"><span>下单成功</span></h2>
        </div>
        <!-- 进度条 -->
        <div class="check-step">
          <ul>
            <li class="cur"><span>预约信息</span></li>
            <li class="cur"><span>确认订单</span></li>
            <li class="cur"><span>下单成功</span></li>
          </ul>
        </div>

        <div class="order-create">
          <div class="order-create-pic"><img src="/static/ok.png" alt=""></div>
          <div class="order-create-main">
            <h3>下单成功! <br></h3>
            <p>
              <!--<span>Order ID：62000000000</span>-->
              <!--<span>Order total：5230</span>-->
            </p>
            <div class="order-create-btn-wrap">
              <div class="btn-l-wrap">
                <a @click="toHome" class="btn btn--m" replace>回首页</a>
              </div>
              <div class="btn-r-wrap">
                <router-link :to="{path:'/mine/orderList',query:{orderType:orderType}}" class="btn btn--m" replace>查看订单</router-link>
              </div>
              <!-- 支付成功，根据显示样本录入按钮 -->
              <div class="btn-n-wrap" >
                  <el-button class="btn btn--m"    v-if="itemType == 3" v-cloak  @click.native.prevent="addOrUpdateHandle(detailItemId,itemId,orderId)">录入样本信息</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--<nav-footer></nav-footer>-->
       <!--标本信息弹框-->
    <sample-add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate"></sample-add-or-update>
    </div>
</template>
<script>
  import '@/assets/css/base.css'
  import '@/assets/css/checkout.css'
  import axios from 'axios'
  import NavHeader from '@/components/Header'
  import NavBread from '@/components/Bread'
  import NavFooter from '@/components/Footer'
  import {getCookie,removeHTMLTag,delCookie} from "../../util/util"
  import SampleAddOrUpdate from '../../components/sample-add-or-update'

    export default{
        data(){
            return{
              p_showSearch:true,
              p_loginModalFlag:false,
              orderType:this.$route.query.orderType,
              itemType:this.$route.query.itemType,
              payNum: this.$route.query.payNum,
              itemId:'',
              orderId:'',
              detailItemId:'',
              addOrUpdateVisible: false,
              code:'',
              providerId: this.$store.state.providerId || localStorage.getItem("providerId") || ''
            }
        },
      components: {
        NavHeader,
        NavBread,
        NavFooter,
        SampleAddOrUpdate,
      },
      mounted() {
        // this.getOrderSample()
        // delCookie("pc")
      },
      methods:{
        p_showLoginModal(){
          this.p_loginModalFlag = true
        },

        p_closeLoginModal(){
          this.p_loginModalFlag = false
        },

         //录入标本 路径;订单详情id;服务项目id;订单id;
        addOrUpdateHandle (detailItemId, itemId, orderId) {
          this.addOrUpdateVisible = true
          this.$nextTick(() => {
            this.$refs.addOrUpdate.init('',detailItemId,itemId,orderId)
          })
        },
         // 通过支付单号获取订单信息
        getOrderSample() {
          axios.get("jys/order/InfoForSaveSample/"+ this.payNum)
          .then((res) => {
            console.log(res)
            if(res.data.code == 0){
              this.itemId = res.data.itemId
              this.orderId = res.data.orderId
              this.detailItemId = res.data.detailItemId
            }
            //  if(res.data.code !== 0) {
            //   this.orderType =''
            //   this.itemType =''
            // }

          })
        },
        toHome() {
          this.providerId?this.$router.push({path: "/company/index", query: {id: this.providerId}}):this.$router.push('/')
        }
      }
    }
</script>

<style>
.order-create-main .order-create-btn-wrap {
  max-width: 360px;
}
.order-create-main .order-create-btn-wrap > div {
  width: 100%;
  margin-bottom: 10px;
}
.order-create-main .order-create-btn-wrap > div >a:hover {
  background-color: #00C5B0;
  color: #fff;
}
@media only screen and (min-width: 320px) and (max-width: 767px) {

  }
[v-cloak] {
  display:none !important;
}
</style>




// WEBPACK FOOTER //
// src/pages/appoint/OrderSuccess.vue